import React from "react";
import l from "components/util/l";
import Executions from "components/vmisc/executions/Executions";
import ChatHistory from "components/presentation/history/chats/ChatHistory";
import Notes from "components/presentation/history/notes/Notes";
import "styles/css/presentation/Presentation.css";

const HistoryView = ({
  notesRef,
  flow,
  chat,
  selectedNote,
  isAdmin,
  historyTab,
  onClickChangeChat,
  onClickSelectNote,
  onClickTab,
}) => (
  <div className="section-container">
    <div className="card pt-1 pb-3 px-2 my-4">
      <div id="history-tabs" className="tabs d-flex mb-0 mt-sm-1 mb-4">
        <button
          type="button"
          className={"dropdown-header " + (historyTab == "chats" ? "active" : "")}
          onClick={() => onClickTab("chats")}>
          Chats
        </button>
        <button
          type="button"
          className={"dropdown-header " + (historyTab == "notes" ? "active" : "")}
          onClick={() => onClickTab("notes")}>
          {l("Notas%PA041")}
        </button>
        <button
          type="button"
          className={"dropdown-header " + (historyTab == "executions" ? "active" : "")}
          onClick={() => onClickTab("executions")}>
          {l("Procesos%PA114")}
        </button>
      </div>

      {
        historyTab == "chats" &&
        <ChatHistory
          flow={flow}
          chat={chat}
          isAdmin={isAdmin}
          refreshKey={Math.random()}
          onClickChangeChat={onClickChangeChat}
        />
      }

      {
        historyTab == "notes" &&
        <Notes
          ref={notesRef}
          flow={flow}
          selectedNote={selectedNote}
          isAdmin={isAdmin}
          onClickSelectNote={onClickSelectNote}
        />
      }

      {
        historyTab == "executions" &&
        <Executions
          flow={flow}
          isAdmin={isAdmin}
        />
      }

    </div>
  </div>
)

export default HistoryView;